import axios from 'axios';

import { AUTH_HEADER } from './utilities/constants';
import { readApiServiceToken } from '../tokens';
import { isAPDomain, isEUDomain, isLocalSurveyDomain } from '@helpers/region';

function getSurveyEndpoint() {
  if (isLocalSurveyDomain) return import.meta.env.VITE_INSTANT_SURVEY_ENDPOINT_LOCAL;
  if (isAPDomain()) return import.meta.env.VITE_INSTANT_SURVEY_ENDPOINT_AP;
  if (isEUDomain()) return import.meta.env.VITE_INSTANT_SURVEY_ENDPOINT_EU;
  return import.meta.env.VITE_INSTANT_SURVEY_ENDPOINT_NA;
}

/**
 * Instant Survey service api instance requiring JWT auth header (setup in redux/sagas/user)
 * @type {import('axios').AxiosInstance}
 */
const api = axios.create({
  baseURL: getSurveyEndpoint(),
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false,
});

/**
 * On a service token expiration error (401), request a new token then retry the initial request
 */
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      const newToken = await readApiServiceToken();

      error.config.headers[AUTH_HEADER] = newToken;
      setInstantSurveyAuthToken(newToken);

      return api(error.config);
    }
    return Promise.reject(error);
  }
);

export const setInstantSurveyAuthToken = (token) => {
  api.defaults.headers.common[AUTH_HEADER] = token;
};

export default api;
